const submissionTransition = {
    CREATE_APPLICATION : 'create application',

    CREATE : 'create application',

    CREATE_SUBMISSION : 'create submission',

    START_PREQUALIFICATION : 'start pre-qualification',

    CANCEL_PREQUALIFICATION : 'cancel pre-qualification',

    CHECK_PREQUALIFICATION : 'check pre-qualification',

    SUBMIT_PREQUALIFICATION : 'submit pre-qualification',

    SET_SUBMISSION_PRODUCTS : 'set submission products',

    MAKE_APPLICATION : 'make application',

    SUBMIT : 'submit',

    CLEARANCE_UNKNOWN : 'risk is unknown',

    CLEAR : 'risk is clear',

    CLEAR_READY : 'clear ready',

    REVERT_TO_CLEAR : 'revert to clear',

    NOT_CLEAR : 'risk is not clear',

    CREATE_QUOTE : 'create quote',

    SEND_QUOTE : 'send quote',

    BIND_QUOTE : 'bind quote',

    UNBIND_QUOTE : 'unbind quote',

    DECLINE_QUOTE : 'decline quote',

    SUBMIT_FOR_ISSUANCE : 'submit for issuance',

    REVERT_TO_BOUND : 'revert to bound',

    ISSUE_QUOTE : 'issue quote',

    ACTION_ISSUED : 'Issued',

    REVERT_TO_PENDING_ISSUANCE : 'revert to pending issuance',

    REFER : 'refer',

    CLEAR_REFERRAL : 'clear referral',

    RETRACT_REFERRAL : 'retract referral',

    DECLINE_REFERRAL : 'decline referral',

    ASSIGN : 'assign',

    ASSIGN_APPLICANT : 'assign applicant',

    PERFORM_CLEARANCE : 'perform clearance',

    DECLINE : 'decline',

    DELETE : 'delete',

    LOST : 'lost',

    REACTIVATE : 'reactivate',

    CHANGE_LINE_OF_BUSINESS : 'change line-of-business',

    CANCEL_POLICY : 'cancel',

    REINSTATE_POLICY : 'reinstate',

    REVERT_TO_ISSUED : 'revert to issued',

    REISSUE_POLICY : 'reissue policy',

    REWRITE_SUBMISSION : 'rewrite submission',

    REWRITE_POLICY : 'rewrite policy',

    REEVALUATE : 'reevaluate',

    UPDATE_STATUS_REASON : 'update status reason',

    RESUBMIT : 'resubmit',

    REJECT : 'reject'

};

angular.module('gw-um-j2js')
    .constant('submissionTransition', submissionTransition);